import { Field } from "@/types";
import { BooleanField } from "./BooleanField";
import { DateField } from "./DateField";
import { Labeled } from "./Labeled";
import { NumericField } from "./NumericField";
import { PatternField } from "./PatternField";
import { TextField } from "./TextField";

type FieldMapProps = Field & {
  data: any;
};

export const FieldMap = ({ data, ...field }: FieldMapProps) => {
  if (field.fieldType === "text") {
    return (
      <Labeled title={field.title}>
        <TextField
          key={field.name}
          data={data}
          name={field.name}
          getValue={field.getValue}
          {...field.fieldProps}
        />
      </Labeled>
    );
  }
  if (field.fieldType === "boolean") {
    return (
      <Labeled title={field.title}>
        <BooleanField
          key={field.name}
          data={data}
          name={field.name}
          getValue={field.getValue}
          {...field.fieldProps}
        />
      </Labeled>
    );
  }
  if (field.fieldType === "pattern") {
    return (
      <Labeled title={field.title}>
        <PatternField
          key={field.name}
          data={data}
          name={field.name}
          getValue={field.getValue}
          {...field.fieldProps}
        />
      </Labeled>
    );
  }
  if (field.fieldType === "date") {
    return (
      <Labeled title={field.title}>
        <DateField
          key={field.name}
          data={data}
          name={field.name}
          getValue={field.getValue}
          {...field.fieldProps}
        />
      </Labeled>
    );
  }
  if (field.fieldType === "numeric") {
    return (
      <Labeled title={field.title}>
        <NumericField
          key={field.name}
          data={data}
          name={field.name}
          getValue={field.getValue}
          {...field.fieldProps}
        />
      </Labeled>
    );
  }

  return null;
};
